module.exports = __webpack_public_path__ + "img/parana.23cf6603.jpg";